import React from "react";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { Accordion, Button, Card } from "react-bootstrap";
import { CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING, CONTRACTS_VISIBLE_MAPPING } from '../../constants';
import {
    checkIfActiveContractForKennitala,
    checkIfInActiveVisibleContractForKennitala,
    countUnsignedAxDocuments,
    EmptyMyPages,
    formatKennitala,
    makeContractsByKennitala,
    plural
} from '../../utils';
import ContractInfo from '../contract-info';
import DetailedCustomerInfo from '../detailed-customer-info';
import MyPagesCreditCard from '../my-pages-creditcard';
import MyPagesSigning from '../my-pages-signing';
import QuestionnaireText from "../questionnaire-text";
import FillQuestionnaire from '../fill-questionnaire'

class MyPagesTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shouldHaveNoBorder: '',
            selectedQuestionnaire: null, 
        }
        this.handleHashChange = this.handleHashChange.bind(this)
    }

    componentDidMount(prevProps) {
        // const no_prev_quest_data = (!prevProps || !prevProps.questionnaires || prevProps.questionnaires.data.length === 0);
        // if (
        //     no_prev_quest_data &&
        //     this.props.questionnaires && this.props.questionnaires.data &&
        //     this.props.questionnaires.data.length > 0) {
        //     this.handleHashChange();
        // }
        window.addEventListener("hashchange", this.handleHashChange);
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.handleHashChange);
    }

    handleHashChange() {
        const hash = window.location.hash;
        const match = hash.match(/#\/spurningalisti\/fill\/(.+)/);
        if (match && match[1]) {
            const token = match[1];
            this.fetchAndDisplayQuestionnaire(token);
        } else {
            this.setState({ selectedQuestionnaire: null });
        }
    };
    
    // fetchAndDisplayQuestionnaire(token) {
    //     let questionnaires = this.props.questionnaires;
    //     if (questionnaires && questionnaires.data && questionnaires.data.length) {
    //         const questionnaire = questionnaires.data.find(q => q.token === token);
    //         if (questionnaire) {
    //             this.setState({ selectedQuestionnaire: questionnaire });
    //         }
    //     }
    // }    


    getCustNameAndKennitala(kennitala) {
        let ktNamePair = Object.entries(this.props.customers.peopleByKennitala).filter(item => item.includes(kennitala))
        let kt = ktNamePair[0][0]
        let name = ktNamePair[0][1]
        return (
            <div className="customer-container">
                <div className="customer">Tryggingaþegi: {name} <span>{formatKennitala(kt)}</span></div>
            </div>)
    }

    onNavLinkClick(currentTab, e) {

        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');

        this.props.setActiveTab(currentTab)
    }

    render() {
        const { signingRecords, customerOffers } = this.props

        let counter = countUnsignedAxDocuments(signingRecords, customerOffers)

        return (<>
            <Tab.Container defaultActiveKey={this.props.activeTab}>
                <div className="tabs-container">
                    <Nav variant="tabs" className="tabs">
                        {signingRecords && signingRecords.data && signingRecords.data.Customer && signingRecords.data.Customer.ElectronicSignatureList && signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature &&
                            <Nav.Item className="check">
                                <Nav.Link eventKey="signings" onClick={this.onNavLinkClick.bind(this, "signings")}>
                                    Skjöl til undirritunar ({counter})
                                </Nav.Link>
                            </Nav.Item>
                        }
                        <Nav.Item className="check">
                            <Nav.Link eventKey="contracts" onClick={this.onNavLinkClick.bind(this, "contracts")}>
                                Tryggingar
                            </Nav.Link>
                        </Nav.Item>
                        {this.props.customerPayers.errorMessage === "" && this.props.customerPayers.customerList.length > 0 && this.props.customerPayers.customerList[0].Contracts.Contract.length > 0 &&
                            <Nav.Item className="check">
                                <Nav.Link eventKey="creditcard" onClick={this.onNavLinkClick.bind(this, "creditcard")}>
                                    Greiðsluupplýsingar
                                </Nav.Link>
                            </Nav.Item>
                        }
                        { /* questionnaires && questionnaires.data  && questionnaires.data.length !== 0 &&
                            <Nav.Item className="check">
                                <Nav.Link eventKey="questionnaires" onClick={this.onNavLinkClick.bind(this, "questionnaires")}>
                                    Skjöl til útfyllingar
                                </Nav.Link>
                            </Nav.Item>
                        */}
                    </Nav>
                </div>
                <Tab.Content className="w-100">
                    {signingRecords && signingRecords.data && signingRecords.data.Customer && signingRecords.data.Customer.ElectronicSignatureList && signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature &&
                        <Tab.Pane eventKey="signings">
                            <div className="heading col-12 col-sm-8 mx-auto mb-5 text-center">
                                {counter > 0 ?
                                    <h2 className="light">{counter} {plural(counter) ? 'skjöl bíða' : 'skjal bíður'} undirritunar</h2>
                                    :
                                    <h2 className="light">Engin skjöl bíða undirritunar</h2>
                                }
                            </div>

                            <MyPagesSigning customerId={this.props.customerId} dispatch={this.props.dispatch} customerOffers={customerOffers} signingRecords={signingRecords} additionalAxDocuments={this.props.additionalAxDocuments}/>
                        </Tab.Pane>
                    }
                    <Tab.Pane eventKey="contracts">

                        {(this.props.customers.errorMessage === "" && this.props.customers.customerList.length > 0 && this.props.customers.customerList[0].Contracts.Contract.length > 0) ?

                            <>
                                {!this.props.customers.isFetching && this.props.customers.customerList.length > 0 && <DetailedCustomerInfo customers={this.props.customers} dispatch={this.props.dispatch} />}

                                {this.props.customers.customerList.map((customer, key) => {
                                    let allContracts =
                                        <div key={key} className="my-pages-container" id="accordion-contracts">
                                            {Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
                                                if (checkIfActiveContractForKennitala(value)) {

                                                    return (
                                                        <React.Fragment key={key}>
                                                            {this.getCustNameAndKennitala(key)}

                                                            {Object.values(value).map((contract) => {

                                                                return contract.map(c => {
                                                                    if (CONTRACTS_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                                                                        return (<React.Fragment key={c.ContractId}>
                                                                            <ContractInfo dispatch={this.props.dispatch} contractId={c.ContractId} tooltips={this.props.tooltips} contracts={this.props.contracts} paymentApplications={this.props.paymentApplications} olderDeclarations={this.props.olderDeclarations} />
                                                                        </React.Fragment>)
                                                                    }
                                                                    return (<></>)
                                                                })
                                                            })}
                                                        </React.Fragment>
                                                    )

                                                } else { return (<></>) }
                                            })}
                                        </div>
                                    return allContracts;

                                })}


                                {this.props.customers.customerList.map((customer, key) => {
                                    return (<React.Fragment key={key}>
                                        {checkIfInActiveVisibleContractForKennitala(customer.Contracts) &&
                                            <>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-12 col-sm-4 col-md-4 col-lg-3 p-5">
                                                        <img className="img-responsive" src={window.images.womanWithBinoculars} />
                                                    </div>
                                                    <div className="col-12 col-sm-8 col-md-6 col-lg-6 p-5">
                                                        <div className="vertical-center">
                                                            Hér að neðan birtast samningar sem eru ekki lengur virkir. Einnig skjöl og upplýsingar um iðgjaldagreiðslur sem tengjast óvirkum samningum.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="my-pages-container" id="accordion-contracts">
                                                    <div className="customer-container">
                                                        <div className="customer">Óvirkir samningar</div>
                                                    </div>
                                                </div>

                                                {this.props.customers.customerList.map((customer) => {
                                                    let allContracts =
                                                        <div className="my-pages-container" id="accordion-contracts">
                                                            {Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
                                                                if (checkIfInActiveVisibleContractForKennitala(value)) {
                                                                    return (
                                                                        <>
                                                                            {Object.values(value).map((contract) => {
                                                                                return contract.map(c => {
                                                                                    if (CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                                                                                        return (<>
                                                                                            <ContractInfo dispatch={this.props.dispatch} contractId={c.ContractId} tooltips={this.props.tooltips} contracts={this.props.contracts} paymentApplications={this.props.paymentApplications} olderDeclarations={this.props.olderDeclarations} />
                                                                                        </>)
                                                                                    }
                                                                                    return (<></>)
                                                                                })
                                                                            })}
                                                                        </>
                                                                    )
                                                                } else { return (<></>) }
                                                            })}
                                                        </div>
                                                    return allContracts;
                                                })}
                                            </>
                                        }
                                    </React.Fragment>)
                                })}
                            </>
                            :
                            <EmptyMyPages />
                        }
                    </Tab.Pane>
                    {this.props.customerPayers.errorMessage === "" && this.props.customerPayers.customerList.length > 0 && this.props.customerPayers.customerList[0].Contracts.Contract.length > 0 &&
                        <Tab.Pane eventKey="creditcard">
                            <MyPagesCreditCard customerId={this.props.customerId} dispatch={this.props.dispatch} />
                        </Tab.Pane>
                    }
                    {/* questionnaires.data && questionnaires.data.length > 0 &&               
                        <Tab.Pane eventKey="questionnaires">
                            {this.state.selectedQuestionnaire ? (
                                <FillQuestionnaire
                                    customerId={this.props.customerId}
                                    selectedQuestionnaire={this.state.selectedQuestionnaire}
                                    onBack={() => this.setState({ selectedQuestionnaire: null })} // Allow user to go back
                                />
                            ) : (
                            <>
                            <div className="heading col-12 col-sm-8 mx-auto mb-5 text-center">
                                <h2 className="light">{questionnaires.data.length} {plural(questionnaires.data.length) ? 'skjöl bíða' : 'skjal bíður'} útfyllingar</h2>
                            </div>
                            <QuestionnaireText/>
                            <Accordion defaultActiveKey="0">
                                { questionnaires.data.map((q_item, key) =>
                                    <Card key={key}>
                                        <Card.Header>
                                            <Accordion.Toggle eventKey="0" as={Button} variant="link" className="toggle-button limited">
                                                <div>
                                                    Aukaspurningar vegna samnings: { q_item.jsondata.additionalQuestions.contractId }
                                                    <p>{ q_item.questioncarriage_titles ? Object.values(q_item.questioncarriage_titles).join(', ') : "" }</p>
                                                </div>

                                                <div className="actions ax-signing justify-content-center">
                                                        <a 
                                                            className="btn btn-primary" 
                                                            href={`/minar-sidur/#/spurningalisti/fill/${q_item.token}`}
                                                        >
                                                        Svara spurningum
                                                        </a>
                                                </div>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                    </Card>

                                )}
                            </Accordion>
                            </>)
                            }
                        </Tab.Pane>
                    */}
                </Tab.Content>
            </Tab.Container>
        </>
        )

    }
}

export default MyPagesTab